<template>
    <sidebar @close="$emit('close')">
        <template v-slot:title v-if="law">
            {{ law.involuntary_withholding_type.name }}
        </template>

        <template v-slot:header v-if="law">
            <div>
                <div>
                    <span class="text-semibold">Jurisdiction: </span>
                    <span>{{ law.jurisdiction_display }}</span>
                </div>

                <div>
                    <span class="text-semibold">Status: </span>
                    <span v-if="law.current_version.is_past">Past</span>
                    <span v-if="law.current_version.is_active">Current</span>
                    <span v-if="law.current_version.is_future">Future</span>
                </div>

                <div>
                    <span class="text-semibold">Has been used: </span>
                    <span v-if="law.has_been_used">Yes</span>
                    <span v-if="!law.has_been_used">No</span>
                </div>
            </div>

            <!-- Tabs -->
            <div class="nav-tabs-container">
                <div class="nav-tabs-scroll-helper">
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a href class="nav-link" :class="{active: activeTab == 'main'}" data-toggle="tab" role="tab" aria-controls="tabContentMain" :aria-selected="activeTab == 'main'" @click.prevent="activeTab='main'">Main</a>
                        </li>

                        <li class="nav-item">
                            <a class="nav-link" :class="{active: activeTab == 'versions'}" href="#tabContentVersions" id="tabVersions" data-toggle="tab" role="tab" aria-controls="tabContentVersions" :aria-selected="activeTab == 'versions'" @click.prevent="activeTab='versions'">Versions</a>
                        </li>
                    </ul>
                </div>
            </div>
        </template>

        <slot v-if="law">
            <div class="tab-content flex-body flex-container">

                <div class="tab-pane flex-body" :class="{'show active': activeTab == 'main'}" id="tabContentMain" role="tabpanel" aria-labelledby="tabLinkMain">
                    <div class="card mb-2">
                        <div class="card-header pr-1 d-flex align-items-center">
                            <span class="btnlike mr-auto">
                                <h4 class="mb-0">Current Version</h4>
                            </span>

                            <button class="btn btn-primary" type="button" @click.prevent="editIsOpen = true">Edit</button>
                            <button class="btn btn-outline-primary ml-1" type="button" @click.prevent="onDelete" v-if="!law.has_been_used">Delete</button>
                        </div>

                        <div class="card-body py-1">
                            <involuntary-withholding-law-version
                                :version="law.current_version"
                                :involuntary-withholding-type="law.involuntary_withholding_type"
                                :filing-statuses="filingStatuses"
                            />
                        </div>
                    </div>
                </div>

                <div class="tab-pane flex-body" :class="{'show active': activeTab == 'versions'}" id="tabContentVersions" role="tabpanel" aria-labelledby="tabLinkVersions">

                    <version-widget :version="version" v-for="version in versions" :key="version.id">
                        <involuntary-withholding-law-version
                            :version="version"
                            :involuntary-withholding-type="law.involuntary_withholding_type"
                            :filing-statuses="filingStatuses"
                        />
                    </version-widget>

                    <p v-if="!versions || !versions.length">
                        Loading...
                    </p>
                </div>
            </div>

            <edit-modal
                v-if="editIsOpen"
                :involuntary-withholding-law="law"
                :involuntary-withholding-types="involuntaryWithholdingTypes"
                @updated="onUpdate($event)"
                @close="editIsOpen = false"
            />
        </slot>
    </sidebar>
</template>

<script>
import Sidebar from '@/components/Sidebar'
import EditModal from './InvoluntaryWithholdingLawModal'
import InvoluntaryWithholdingLawVersion from './InvoluntaryWithholdingLawVersion'
import VersionWidget from './VersionWidget'
import FILING_STATUSES from './involuntaryWithholdingFilingStatuses'

export default {
    components: {Sidebar, EditModal, InvoluntaryWithholdingLawVersion, VersionWidget, },
    props: ['involuntaryWithholdingLawId', 'involuntaryWithholdingTypes'],
    computed: {
        filingStatuses() {
            return FILING_STATUSES
        },
        versions() {
            if (!this.law) {
                return []
            }
            return Array.from(this.law.versions).sort((a, b) => a.created_on < b.created_on ? 1 : -1)
        },
    },
    data() {
        return {
            editIsOpen: false,
            activeTab: 'main',
            law: null,
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/admin/tax-engine/involuntary-withholding-laws/${this.involuntaryWithholdingLawId}`).then(resp => {
                this.law = resp
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
        onDelete() {
            if (!confirm("Are you sure?")) {return}

            this.$store.dispatch('START_LOADING')
            this.$api.del(`/admin/tax-engine/involuntary-withholding-laws/${this.law.id}`).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('deleted')
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
        onUpdate($evt) {
            if ($evt) {
                this.$emit('updated', $evt)
            }
            else {
                this.$emit('updated')
            }

            this.getData()
        },
    },
}
</script>
